module.exports = __webpack_public_path__ + "img/symbol_5.196906f3.png";